// extracted by mini-css-extract-plugin
module.exports = {"artDisabled":"RichEditor_artDisabled_galfS"};